import { removeSubdomain, removePort, sanitizeInput, validateHost } from './sanitizeAndValidate.js';

/**
 * Generates a domain based on the provided host.
 *
 * This function sanitizes the input host by removing the subdomain and port,
 * then validates the sanitized host. If the sanitized host is 'localhost' or
 * contains 'js.wpenginepowered', it returns the `defaultDomain`.
 * Otherwise, it returns the sanitized host.
 *
 * @param {string} host - The host input to generate the domain from.
 * @returns {string} - The generated domain.
 */
function generateDomain(host, defaultDomain) {
    // Sanitize the host input
    var sanitizedHost = removeSubdomain(removePort(sanitizeInput(host)));
    validateHost(sanitizedHost);
    // If the host is localhost or contains js.wpenginepowered, use the default `domain` values from the config
    if (sanitizedHost.includes('localhost') ||
        sanitizedHost.includes('js.wpenginepowered')) {
        return defaultDomain;
    }
    return sanitizedHost;
}

export { generateDomain as default };
